import { useState } from 'react';
// import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import SearchIcon from '@mui/icons-material/Search';
// import AddIcon from '@mui/icons-material/Add';
// import React, {useState} from 'react'
import { useMemberState } from '../contexts/membercontext'
import { useLoadMessages } from '../hooks/memberhooks'
// import NewSearch from './NewSearch'
// import NewSearch from '../components/NewSearch'
import { GroupedMessageListType, MembershipSchema, MessageSchema } from "../data/types";
import { ReactComponent as Avatar } from '../icons/ChatbotIcon.svg'
// import { ReactComponent as NewMessageIcon } from '../icons/NewMessage.svg'
import { NewMessageModal } from './AppModal';
import UserAvatar from '../components/UserAvatar';

// const capitalizeString = (string: string) => string?.replace(/\w/, c => c?.toUpperCase())

const MessageTabs = [
    { label: 'Unread', count: 1 },
    { label: 'Read', count: 1 },
    { label: 'Sent', count: null },
];

type UserListWindowProps = {
    memberships?: MembershipSchema[]
}

const UserListWindow: React.FC<UserListWindowProps> = ({ memberships }) => {
    var { currentChatMember, allThreadsByMembers, messageOpen, setMessageOpen } = useMemberState()
    const [searchTerm, setSearchTerm] = useState('')
    const [activeTab, setActiveTab] = useState('Unread')
    

    return (
        <div className="w-11/12 mx-auto h-screen bg-white p-2">
            {/* Search Bar and Add Button */}
            <div className="flex items-center gap-2 mb-4">
                <div className="flex items-center bg-white border-[1px] border-[#E9E9E9]/90 rounded-full h-10 px-3 py-2 flex-1">
                    <SearchIcon className="text-gray-400 mr-2" fontSize="small" />
                    <input
                        className="bg-transparent outline-none border-none text-sm flex-1 placeholder:text-[#808080]/50 placeholder:font-raleway"
                        placeholder="Search for messages or members"
                        value={searchTerm}
                        onChange={e => setSearchTerm(e.target.value)}
                    />
                </div>
                <div className="flex ml-1 items-center cursor-pointer justify-center border-[1px] border-[#E9E9E9]/90 hover:bg-[#E9E9E9] rounded-xl h-10 w-10">
                    <button
                        className=" bg-transparent border-[1.5px] font-medium text-[16px] border-black text-black m-auto h-4 w-4 rounded-full p-2 flex items-center justify-center"
                        onClick={() => setMessageOpen(true)}
                    >
                        +
                    </button>
                </div>
            </div>
            {/* Tabs */}
            <div className="flex gap-2 mb-2">
                {MessageTabs.map(tab => (
                    <button
                        key={tab.label}
                        className={`px-3 py-1 rounded-full text-xs font-semibold border ${activeTab === tab.label ? 'bg-[#E6F7FB] text-[#51a0b5] border-[#51a0b5]' : 'bg-white text-[#7A7A7A] border-[#E0E0E0]'} transition`}
                        onClick={() => setActiveTab(tab.label)}
                    >
                        {tab.label} {tab.count !== null && <span className="mx-0">({tab.count})</span>}
                    </button>
                ))}
            </div>
            <NewMessageModal 
                isOpen={messageOpen} 
                closeAppModal={() => setMessageOpen(false)} 
            />
            <div>
                {/* CHATBOT MESSAGES */}
                <ChatUser currentChatMember={currentChatMember} allThreadsByMembers={allThreadsByMembers} />
                {/* MEMBER MESSAGES */}
                {
                    allThreadsByMembers !== undefined ? Object.keys(allThreadsByMembers).map((member: string, i: number) => {
                        const currentMember = memberships?.find((m: MembershipSchema) => m.uid === member)
                        return (member !== 'chatbot') ? (
                            <ChatUser key={i} currentChatMember={currentChatMember} member={currentMember as MembershipSchema} allThreadsByMembers={allThreadsByMembers} />
                        ) : null
                    }) : null
                }
            </div>
        </div>
    )
}

type ChatUserProps = {
    member?: MembershipSchema
    currentChatMember: string
    allThreadsByMembers: GroupedMessageListType
}

const ChatUser: React.FC<ChatUserProps> = ({ member, currentChatMember, allThreadsByMembers }) => {
    let messages: MessageSchema[] = (allThreadsByMembers !== undefined && member?.uid) ? allThreadsByMembers[member?.uid] : allThreadsByMembers['chatbot']
    let last_message = allThreadsByMembers && messages ? messages[messages.length - 1] : null
    const { switchMember } = useLoadMessages()
    const [imageError, setImageError] = useState(false);

    // Dummy data for unread count and time (replace with real logic as needed)
    const unreadCount = last_message && !last_message.read_status && last_message.type === 'received' ? 1 : null
    const time = last_message ? '2:14 PM' : '' // Replace with real time formatting

    const handleClick = (member: string) => {
        switchMember(member)
    }

    return (
        <div
            style={{ backgroundColor: (member?.uid === currentChatMember || (!member?.uid && currentChatMember === 'chatbot')) ? '#eef7fa' : '#fff' }}
            className={`flex items-center px-3 py-2 cursor-pointer rounded-lg transition mb-1 ${member?.uid === currentChatMember ? 'shadow-sm' : ''}`}
            onClick={() => handleClick(member?.uid || 'chatbot')}
        >
            {!member?.uid ? (
                // Chatbot avatar
                <Avatar className="h-10 w-10 text-[#51a0b5]/90" />
            ) : (
                // Member avatar with fallback
                member.avatar && !imageError ? (
                    <img
                        src={member.avatar}
                        alt="User Avatar"
                        className="h-10 w-10 rounded-full object-fit object-center"
                        onError={() => setImageError(true)}
                    />
                ) : (
                    <UserAvatar
                        firstName={member?.first_name}
                        lastName={member?.last_name}
                        username={member?.username}
                        email={member?.email}
                        size="md"
                    />
                )
            )}
            <div className="flex flex-col flex-1 ml-3 min-w-0">
                <span className="font-semibold text-sm text-[#2D3748] truncate">
                    {!(member?.uid) ? 'HomeCook AI' :
                        (!member?.first_name && !member?.last_name)
                            ? (member?.username || member?.email || '')
                            : [member?.first_name, member?.last_name].filter(Boolean).join(' ')
                    }
                </span>
           
                {last_message && (
                    <span className="text-xs text-[#7A7A7A] truncate max-w-[160px]">
                        {last_message.content && last_message.content.length > 40 ? `${last_message.content.slice(0, 40)}...` : last_message.content}
                    </span>
                )}
            </div>
            <div className="flex flex-col items-end ml-2 min-w-[48px]">
                <span className="text-[11px] text-[#7A7A7A] mb-1">{time}</span>
                {unreadCount && (
                    <span className="bg-[#5db6ce] text-white text-[11px] font-bold rounded-full px-2 py-0.5 flex items-center justify-center">
                        {unreadCount}
                    </span>
                )}
            </div>
        </div>
    )
}

export default UserListWindow
